import type Booleanish from '../types/Booleanish'
import { computedEager } from '@vueuse/shared'

export class BooleanLike {
  static use(
    el:
      | Ref<Booleanish>
      | Ref<Booleanish | undefined>
      | Ref<Booleanish | null>
      | Ref<Booleanish | undefined | null>
  ):
    | Readonly<Ref<boolean>>
    | Readonly<Ref<boolean | undefined>>
    | Readonly<Ref<boolean | null>>
    | Readonly<Ref<boolean | undefined | null>> {
    return computedEager(() =>
      el.value === undefined || el.value === null ? el.value : resolveBooleanish(el.value)
    )
  }
}
